"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Box = _interopRequireDefault(require("../../layout/Box"));

var _colorUtils = require("../../utils/colorUtils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ContentBox = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Placeholder__ContentBox",
  componentId: "sc-1d0kerg-0"
})(function (_ref) {
  var theme = _ref.theme,
      rounded = _ref.rounded,
      width = _ref.width,
      height = _ref.height,
      pauseAnimation = _ref.pauseAnimation;
  return (0, _styledComponents.css)(["border-radius:", ";background:", ";", " @keyframes shimmer{0%{background-position-x:0;}100%{background-position-x:4000px;}}"], rounded ? width === height ? '50%' : '9999px' : '0.25rem', (0, _colorUtils.hexToRGBA)(theme.color.structure, 0.5), !pauseAnimation && (0, _styledComponents.css)(["background:linear-gradient( to right,", " 0%,", " 25%,", " 50% );background-size:4000px 100%;animation:shimmer 1.8s linear infinite;"], (0, _colorUtils.hexToRGBA)(theme.color.structure, 0.5), (0, _colorUtils.hexToRGBA)(theme.color.structure, 0.1), (0, _colorUtils.hexToRGBA)(theme.color.structure, 0.5)));
});
/**
 * When content is being fetched asynchronously, the **Placeholder** component can provide a visual indication to the user that the content is loading. Several **Placeholder**s can be sized and grouped appropriately to match the expected content that is being fetched. For accessibility purposes, the parent container should be given an `aria-disabled="true"` or `aria-label="loading"` attribute so that screen readers will interpret them correctly.
 */

var Placeholder = function Placeholder(_ref2) {
  var _ref2$element = _ref2.element,
      element = _ref2$element === void 0 ? 'div' : _ref2$element,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? '100%' : _ref2$height,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '100%' : _ref2$width,
      _ref2$rounded = _ref2.rounded,
      rounded = _ref2$rounded === void 0 ? false : _ref2$rounded,
      _ref2$pauseAnimation = _ref2.pauseAnimation,
      pauseAnimation = _ref2$pauseAnimation === void 0 ? false : _ref2$pauseAnimation,
      rest = _objectWithoutProperties(_ref2, ["element", "height", "width", "rounded", "pauseAnimation"]);

  return /*#__PURE__*/_react["default"].createElement(ContentBox, _extends({
    element: element,
    height: height,
    rounded: rounded,
    width: width,
    pauseAnimation: pauseAnimation
  }, rest));
};

var _default = Placeholder;
exports["default"] = _default;